<template>
  <div class="exact-modal-step exact-modal-step--basic">
    <div class="report-name">
      <ui-input-text
        :type="'text'"
        :placeholder="$t('dashboard.expandDomain.placeHolder')"
        :modelValue="reportName"
        :byteLimit="950"
        :isInputAbove="false"
        labelPosition="left"
        @input="$emit('update:report-name', $event)"
      >
        <p class="input-label">{{ $t('dashboard.expandDomain.label') }}</p>
      </ui-input-text>
    </div>
    <div class="notice">
      <ul class="notice-list">
        <li v-html="$t('dashboard.expandDomain.description.1')"></li>
        <li v-html="$t('dashboard.expandDomain.description.2')"></li>
        <li v-html="$t('dashboard.expandDomain.description.3')"></li>
      </ul>
    </div>
    <a class="guide-link" :href="categoryLegendLink" target="_blank">
      <i class="icon icon--tooltip-link"></i>
      <span>{{ $t('dashboard.expandDomain.link') }}</span>
    </a>
    <hr class="border">
  </div>
</template>

<script>
import UiInputText from '@/components/ui/UiInputText'

export default {
  name: 'SettingExactBasic',
  components: { UiInputText },
  props: {
    reportName: {
      type: String,
      default: ''
    }
  },
  computed: {
    categoryLegendLink () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://forum.beusable.net/ko/solomon/post/2362'
        case 'ja':
          return 'https://forum.beusable.net/ja/solomon/post/2364'
        case 'en':
          return 'https://forum.beusable.net/en/solomon/post/2363'
      }
      return 'https://forum.beusable.net/ko/solomon/post/2362'
    }
  }
}
</script>

<style lang="scss" scoped>
.exact-modal-step {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 100%;
}

.report-name {
  .input-label {
    width: 100px;
  }
}

.notice {
  width: 100%;
  padding: 20px;
  border-radius: 6px;
  border: 1px solid #d7d7d7;
  background-color: #f4f4f4;
  box-sizing: border-box;

  &-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: #666;
    font-size: 13px;
    line-height: 1.5;
    list-style-type: disc;
    padding-left: 20px;
  }
}

.guide-link {
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  padding-left: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #0074ff;

  .icon--tooltip-link {
    transform: rotate(90deg);
  }
}

.border {
  flex-shrink: 0;
  height: 1px;
  margin: 0;
  border: none;
  background: #d7d7d7;
}
</style>
